var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-breadcrumb", { attrs: { name: "My Account" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "4", md: "5" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { "second-body": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "second-body",
                      fn: function () {
                        return [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Email address"),
                          ]),
                          _vm._v(" "),
                          _c("h6", [_vm._v(_vm._s(_vm.user.email))]),
                          _vm._v(" "),
                          _vm.user.phone
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Phone"),
                                ]),
                                _vm._v(" "),
                                _c("h6", [_vm._v(_vm._s(_vm.user.phone))]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user.date_birth
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Date Birth"),
                                ]),
                                _vm._v(" "),
                                _c("h6", [_vm._v(_vm._s(_vm.user.date_birth))]),
                              ]
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    { staticClass: "mt-3 text-center" },
                    [
                      _c("b-avatar", {
                        attrs: {
                          variant: "primary",
                          src: _vm.user.avatar_url,
                          text: _vm.avatarLetters,
                          size: "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("h4", { staticClass: "card-title mt-3" }, [
                        _vm._v(_vm._s(_vm.fullName)),
                      ]),
                      _vm._v(" "),
                      _vm.user.position
                        ? _c("h6", { staticClass: "card-subtitle" }, [
                            _vm._v(_vm._s(_vm.user.position)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.company
                        ? _c("h6", { staticClass: "card-subtitle" }, [
                            _vm._v(_vm._s(_vm.user.company.name)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { lg: "8", md: "7" } },
            [
              _c(
                "admin-panel",
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "First Name" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              state: _vm.fieldValid("first_name"),
                            },
                            model: {
                              value: _vm.formData.first_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "first_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.first_name",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("first_name") } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.formValidation.first_name) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Last Name" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.formData.last_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "last_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.last_name",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("last_name") } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.formValidation.last_name) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Login" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.formData.login,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "login",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.login",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("login") } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.formValidation.login) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Email" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.formData.email,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "email",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.email",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("email") } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.formValidation.email) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Position" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.formData.position,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "position",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.position",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("position") } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.formValidation.position) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Admin Notifications" } },
                        _vm._l(
                          _vm.adminNotificationClasses,
                          function (nClass, key) {
                            return _c(
                              "div",
                              { key: key },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    key: key,
                                    model: {
                                      value:
                                        _vm.formData.notifications[
                                          nClass.class
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.notifications,
                                          nClass.class,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.notifications[nClass.class]",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(nClass.name) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "mb-1 d-inline-block font-italic" },
                        [
                          _vm._v(
                            "Leave password fields empty if you don't want to update your current password"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "New Password" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.formData.password,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "password",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.password",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("password") } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.formValidation.password) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Confirm New Password" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.formData.password_confirmation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "password_confirmation",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.password_confirmation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            disabled: _vm.formState.processing,
                          },
                        },
                        [
                          _vm._v(
                            "\n              Update your Profile\n              "
                          ),
                          _vm.formState.processing
                            ? _c("b-spinner", {
                                staticClass: "ml-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }